import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const HAIRCARE_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  1: setDirectAnswerPreset(
    undefined,
    "CAROLS DAUGHTER Hair Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the CAROLS DAUGHTER Hair Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.carols_daughter_oos_before()
  ),
  2: setDirectAnswerPreset(
    undefined,
    "Garnier FRUCTIS Hair Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Garnier FRUCTIS Hair Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.fructis_oos_before()
  ),
  3: setDirectAnswerPreset(
    undefined,
    "L'Oreal ELVIVE Hair Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the L'Oreal ELVIVE Hair Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.elvive_oos_before()
  ),
  4: setDirectAnswerPreset(
    undefined,
    "L'Oreal EVER Hair Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the L'Oreal EVER Hair Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.ever_oos_before()
  ),
  5: setDirectAnswerPreset(
    undefined,
    "Garnier WHOLE BLENDS Hair Care Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the Garnier WHOLE BLENDS Hair Care category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.whole_blends_oos_before()
  ),

  6: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Carols Daughter's Hair Care you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.carols_daughter_stocked()
  ),
  7: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Garnier Fructis Hair Care you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.fructis_stocked()
  ),
  8: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of L'Oreal Elvive Hair Care you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.elvive_stocked()
  ),
  9: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of L'Oreal Ever Hair Care you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.ever_stocked()
  ),
  10: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of Garnier Whole Blends Hair Care you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].haircare.whole_blends_stocked()
  ),

  11: setDependentAnswerPreset(
    undefined,
    "Garnier FRUCTIS Hair Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [2],
    beautyUtils.getAfterOOSCount
  ),
  12: setDependentAnswerPreset(
    undefined,
    "L'Oreal ELVIVE Hair Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [3],
    beautyUtils.getAfterOOSCount
  ),
  13: setDependentAnswerPreset(
    undefined,
    "L'Oreal EVER Hair Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [4],
    beautyUtils.getAfterOOSCount
  ),
  14: setDependentAnswerPreset(
    undefined,
    "Garnier WHOLE BLENDS Hair Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [5],
    beautyUtils.getAfterOOSCount
  ),
  15: setDependentAnswerPreset(
    undefined,
    "CAROLS DAUGHTER Hair Care: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [1],
    beautyUtils.getAfterOOSCount
  ),

  16: setDependentAnswerPreset(
    undefined,
    "Garnier FRUCTIS Hair Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [11],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  17: setDependentAnswerPreset(
    undefined,
    "L'Oreal ELVIVE Hair Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [12],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  18: setDependentAnswerPreset(
    undefined,
    "L'Oreal EVER Hair Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [13],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  19: setDependentAnswerPreset(
    undefined,
    "Garnier WHOLE BLENDS Hair Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [14],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  20: setDependentAnswerPreset(
    undefined,
    "CAROLS DAUGHTER Hair Care: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [15],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),

  21: setDependentAnswerPreset(
    undefined,
    "Garnier FRUCTIS Hair Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [16],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  22: setDependentAnswerPreset(
    undefined,
    "L'Oreal ELVIVE Hair Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [17],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  23: setDependentAnswerPreset(
    undefined,
    "L'Oreal EVER Hair Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [18],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  24: setDependentAnswerPreset(
    undefined,
    "Garnier WHOLE BLENDS Hair Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [19],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  25: setDependentAnswerPreset(
    undefined,
    "CAROLS DAUGHTER Hair Care: What is the total number DPCIs in which the counts WERE CORRECTED",
    "text",
    [20],
    beautyUtils.getTotalDPCIsCountCorrected
  ),
  26: setDependentAnswerPreset(
    undefined,
    "Did a Team Lead assist you during your service to correct any Hair Care counts",
    "radio",
    [16, 17, 18, 19, 20],
    beautyUtils.getDidATeamMemberAssistYouWithUpdatingOnHands
  ),
  // 27: setDependentAnswerPreset(
  //   /Hair Care/i,
  //   "Select why 0 Items needed a count correction",
  //   "radio",
  //   [11, 12, 13, 14, 15],
  //   beautyUtils.getWhyZeroItemsNeededCountCorrection
  // ),
};
